<template>
    <div class="container">
        <div class="left-wrapper">
            <div class="left-top">
                <div class="icon-wrapper">
                    <img :src="require('@/assets/icons/murugesh-logo.svg')" alt="">
                </div>
                <p class="name">Murugesh Raja<span class="dot">.</span></p>
            </div>
            <div class="text-wrapper">
                <p class="title">Let's Connect</p>
                <p class="description">Designed & Developed with ♥ by Murugesh Raja</p>
            </div>
        </div>
            
        <div class="right-wrapper">
            <div class="section">
                <p class="sec-title">Reach me at</p>
                <a class="link href" href="https://www.linkedin.com/in/murugesh-raja/">LinkedIn</a>
                <a class="link href" href="https://github.com/MurugeshRajaR">Github</a>
                <button class="link" @click="openWhatsApp">Whatsapp</button>
                <a class="link href" href="https://www.instagram.com/murugesh_raja_r">Instagram</a>
            </div>
            <div class="section">
                <p class="sec-title">Contact</p>
                <button class="link" @click="openPhone">+91 882579 1739</button>
                <button class="link" @click="openMail">murugeshraja2000@gmail.com</button>
            </div>
        </div>
    </div>
</template>

<script>
import { openPhone, openWhatsApp, openMail } from '@/utils/contactHelper';

export default {
    name: 'FooterComponent',
    methods: {
        openPhone, openWhatsApp, openMail 
    }
}
</script>

<style scoped>
.container {
    width: 100%;
    display: flex;
    gap: 80px;
    padding: 60px 120px;
    font-family: 'Sans';
    background-color: var(--primary-bg-color);
}

.name {
    font-size: 32px;
    font-weight: 600;
    color: var(--primary-text-color);
    font-family: 'PlayBall';
}

.icon-wrapper {
    display: flex;
    align-items: center;
    padding: 12px;
    border-radius: 50%;
    background: #0C0C0D;
    border: 1px solid #252626;
    width: 72px;
    height: 72px;
    overflow: hidden;
}

.dot {
    color: #FFA84B;
}

.left-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.right-wrapper {
    display: flex;
    gap: 48px;
}

.section {
    display: flex;
    flex-direction: column;
    gap: 12px;
    font-size: 1rem;
    line-height: 1.5rem;
}

.left-top {
    display: flex;
    gap: 16px;
    align-items: center;
}

.text-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.title {
    font-family: 'Poppins';
    font-size: 1rem;
    font-weight: 500;
    line-height: 27px;
}

.description {
    color: var(--secondary-text-color);
    font-family: 'Poppins';
    font-size: 18px;
    font-weight: 500;
    line-height: 27px;
}

.sec-title {
    color: var(--secondary-text-color);
    text-align: left;
}

.link {
    color: var(--primary-text-color);
    border: none;
    outline: none;
    background-color: transparent;
    text-align: left;
    word-break: break-word;
}

.link.href {
    cursor: pointer;
    text-decoration: none;
}

@media (max-width: 768px) {
    .icon-wrapper {
        width: 50px;
        height: 50px;
        overflow: hidden;
    }

    .icon-wrapper img {
        width: 40px;
        height: 40px;
    }
}


@media (max-width: 700px)  {
    .container {
        padding: 32px;
        gap: 32px;
        flex-direction: column;
    }

    .tabs-wrapper {
        flex-direction: column;
    }

    .left-wrapper {
        gap: 18px;
    }

    .text-wrapper {
        gap: 8px;
    }

    .name {
        font-size: 1.3rem;
    }

    .description {
        font-size: 0.9rem;
    }

    .link {
        font-size: 1rem;
        white-space: nowrap;
        overflow: hidden;
        width: 100%;
        text-overflow: ellipsis;
    }

    .right-wrapper {
        flex-direction: column;
        gap: 1rem;
    }


}
</style>